export const downloadCSV = async () => {
  // Add small delay to ensure DOM is fully rendered (React 19 compatibility)
  await new Promise(resolve => setTimeout(resolve, 100));
  
  const sections = document.querySelectorAll('.section'); // Select all rendered tables
  const csvSections: string[] = [];
  const statementType: string =
    document
      .querySelector('[data-testid="statement-type"]')
      ?.textContent?.toString()
      .replaceAll(/,/g, '') || '';
  const cocode: string =
    document.querySelector('[data-testid="report-cocode"]')?.textContent?.trim() || '';
  const year: string =
    document.querySelector('[data-testid="report-year"]')?.textContent?.trim() || '';

  sections.forEach((section) => {
    let sectionTitle =
      section.querySelector('.section_title')?.textContent?.replaceAll(/[,;]/g, '').trim() ||
      'Untitled Section';

    // Updated selector to work with CSS modules
    const subSections = section.querySelectorAll("div[class*='body']");

    subSections.forEach((subSection) => {
      // Look for containers with h5 elements (header row)
      const headerContainer = subSection.querySelector("div[class*='container']");
      const headers = Array.from(headerContainer?.querySelectorAll('h5') || []).map(
        (header) => header?.textContent?.replaceAll(/[,;]/g, '').trim() || ''
      );

      // Get all data containers
      const allContainers = Array.from(subSection.querySelectorAll("div[class*='container']"));
      const dataContainers = allContainers.filter(container => 
        !container.querySelector('h5') && container.querySelector('p')
      );

      const rows = getCellNameWithoutComma(dataContainers);
      
      // Build CSV for this SubSection
      const csvContent = [
        sectionTitle, // Section title as a header
        headers.join(','),
        ...rows.map((row: any) => row.join(',')) // Add data rows
      ].join('\n');

      csvSections.push(csvContent);
    });
  });

  // Combine all sections into one CSV
  const fullCSV = csvSections.join('\n\n');
  const blob = new Blob([fullCSV], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);

  // Trigger file download
  const getFileName = document.getElementById('selected-report-view');
  const a = document.createElement('a');
  a.href = url;
  a.download =
    cocode + '-' + statementType + '-' + year + '-' + getFileName?.innerText || 'NAIC.csv';
  a.click();

  // Cleanup
  URL.revokeObjectURL(url);
};

const getCellNameWithoutComma = (dataContainers: any) =>
  dataContainers.map((container: any) =>
    Array.from(container.querySelectorAll('p')).map((cell: any) =>
      cell?.textContent ? cell.textContent?.replaceAll(/[;,]/g, '').trim() : ''
    )
  );
